/**
 * 权限配置相关请求
 */
import { HttpV1,Http } from '@/request'

// 获取权限配置
export async function getPermission () {
  return await HttpV1.get(`/agent/config/show`)
}